(() => {
  const key = '__kennasCartSuggestionLabels';
  if (window[key]) { window[key](); return; }
  const roots = '#site-cart-sidebar cart-recommendations, .cart-section .cart-product-recommendations';
  const watched = new WeakSet();
  function rename(root) {
    root.querySelectorAll('.actions a, .actions button').forEach(button => {
      if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        if (node.textContent.trim().toLowerCase() === 'choose options') {
          node.textContent = node.textContent.replace(/choose options/i, 'Buy now');
        }
      });
      if ((button.getAttribute('aria-label') || '').toLowerCase() === 'choose options') {
        button.setAttribute('aria-label', 'Buy now');
      }
    });
  }
  function scan() {
    document.querySelectorAll(roots).forEach(root => {
      rename(root);
      if (watched.has(root)) return;
      watched.add(root);
      new MutationObserver(() => rename(root)).observe(root, {
        childList: true, subtree: true, characterData: true
      });
    });
  }
  window[key] = scan;
  scan();
  document.addEventListener('DOMContentLoaded', scan, { once: true });
  document.addEventListener('shopify:section:load', scan);
})();
